
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import PageFooter from '@/components/page-footer.vue'

  @Component({
    name: 'category-child',
    components: {
      PageFooter
    }
  })
  export default class CategoryChild extends Vue {
    private productNameKey = '';
    private list = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];

    private searchName(queryString: string, cb: any) {

    }

    private handleSelect(item: any) {
      console.log(item)
    }
  }
